/* eslint-disable max-len */
export default function authAdminHeader() {
      // for Node.js Express back-end
    return { 'x-access-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6InVzbWFuLm5hZWVtQGFtY29pdHN5c3RlbXMuY29tIiwiYWRkcmVzcyI6IjB4NzBFRjVENjc1Y2I1RjdiM2Q1MzAzODNhM0QwQjgxNjAzNUY0OTlBRCIsImlhdCI6MTY5NjkxNTkzNywiZXhwIjoxNzgzMzE1OTM3fQ.HbgIVyZ7zcBLQlxN4cQHMQbrPRofhGv-JJ0Lv7DJgiw' };
  }
